export default "__VITE_ASSET__BZRfawrR__"